var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-search',{staticClass:"wc-search",attrs:{"shape":"round","placeholder":_vm.placeholder},on:{"search":function($event){return _vm.$emit('search', _vm.searchText)},"input":function($event){return _vm.$emit('input', _vm.searchText)}},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})
}
var staticRenderFns = []

export { render, staticRenderFns }